'use client';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useEffect } from 'react';

export default function CustomAnalyticsContext() {
  const { setContext } = useAnalytics();

  useEffect(() => {
    const location = window.location.pathname;
    const query = location.split('/').at(-2);
    setContext('product_page', {
      item_id: Number(query),
      stock_status: 'no_stock_status_available'
    });
  }, [setContext]);

  return null;
}
